export default "__VITE_ASSET__Cqs4JjlF__"